import { supabase } from "./supabase";

// Dados da aba Contratos de Parceiros. Nada novo no banco: o texto dos termos
// vem de termo_versoes (api/termo, leitura pública) e quem aceitou o quê vem de
// termo_aceites (api/aceites, só equipe logada — tem CPF e IP).

// Módulos com termo próprio. Rastreamento não tem: o contrato dele é a ficha.
export const MODULOS_TERMO = [
  { modulo: "MANUTENCAO", label: "Manutenção", sistema: "manutencao", color: "#7c3aed" },
  { modulo: "COMBUSTIVEIS", label: "Combustível", sistema: "combustivel", color: "#0d9488" },
];

// Todas as versões já publicadas de um módulo, da mais nova para a mais antiga.
// Cada aceite vale pelo texto da versão que a pessoa leu, então a via do
// fornecedor precisa da versão dele, não da vigente.
export async function carregarVersoes(modulo) {
  try {
    const res = await fetch(`/api/termo?modulo=${modulo}&incluir=versoes`);
    const json = await res.json().catch(() => ({}));
    if (!res.ok) return [];
    return [...(json.versoes || [])].reverse();
  } catch {
    return [];
  }
}

// Aceites de todos os fornecedores, agrupados por ficha. Revogados ficam de
// fora: não se manda a ninguém um aceite que deixou de valer.
export async function carregarAceitesPorFicha() {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) return { ok: false, erro: "Sessão expirada. Entre de novo." };
  try {
    const res = await fetch("/api/aceites?todos=1", { headers: { Authorization: `Bearer ${session.access_token}` } });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) return { ok: false, erro: json.error || "Não foi possível carregar os aceites." };
    const porFicha = {};
    for (const a of json.aceites || []) {
      if (a.revogado_em || !a.credenciado_id) continue;
      const lista = (porFicha[a.credenciado_id] ||= []);
      // A lista chega do mais recente para o mais antigo: o primeiro de cada
      // módulo é o que vale.
      if (!lista.some((x) => x.modulo === a.modulo)) lista.push(a);
    }
    return { ok: true, porFicha };
  } catch {
    return { ok: false, erro: "Não foi possível carregar os aceites." };
  }
}

// Nome de arquivo sem acento nem espaço, que abre em qualquer celular.
export const nomeArquivo = (...partes) =>
  partes.filter(Boolean).join("-").normalize("NFD").replace(/[̀-ͯ]/g, "")
    .toLowerCase().replace(/[^a-z0-9.]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 90);
